module.exports = __webpack_public_path__ + "img/Star.8945226f.svg";